import { RequestBasePageId, ResponseBaseSet } from "@myapp/modules/fwcore/models/messages";
import { DealSummary } from "../deal-summary";

export class RequestDealName extends RequestBasePageId {
  /**
 * The identifier of the company to filter deals by.
 */
  companyId?: string | null;

  /**
   * Indicates whether only active deals should be included.
   */
  isActive?: boolean | null;

  /**
   * A string that the deal name should start with for filtering.
   */
  startsWith?: string | null;

  /**
   * The identifier of the deal group to filter deals by.
   */
  dealGroupId?: string | null;

  /**
   * The identifier of the deal folder to filter deals by.
   */
  dealFolderId?: string | null;

  /**
   * Indicates whether to include only deals that have been received.
   */
  onlyReceived?: boolean | null;

  /**
   * Indicates whether to include only deals shared with the current user.
   */
  sharedWith?: boolean | null;

  /**
   * The company identifier for whom we wish to filter deals created for
   */
  userCompanyId?: string | null;

  /**
  * The user group code to validate permissions against.
  */
  userGroupCode?: string | null;

  /**
 * The status code for the deals to match.
 */
  dealStatusCode?: string | null;

  /**
   * Indicates whether to include all deals associated with the user's company.
   */
  viewCompanyDeals?: boolean | null;

  /**
 * Indicates whether to include only deals that are Unopened.
 */
  Unopened?: boolean | null;

  /**
  * Indicates whether to include only deals that have been updated.
  */
  Updated?: boolean | null;
}

export class ResponseDealName extends ResponseBaseSet<DealSummary> { }
